export function loadScript(url: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const scriptTags = Array.from(document.querySelectorAll('script'));
    const doesTagExist = scriptTags.some(tag => tag.src === url);
    if (doesTagExist) {
      reject(new Error('Script tag already exist'));
    }

    const scriptElement = window.document.createElement('script');
    scriptElement.src = url;
    scriptElement.async = true;
    scriptElement.defer = true;
    scriptElement.onload = () => {
      resolve(true);
    };
    scriptElement.onerror = () => {
      reject(new Error(`Unable to load "${url}"`));
    };

    window.document.body.appendChild(scriptElement);
  });
}
